<header>
  <div class="header-row logo-row">
    <img src="/assets/innogy-icons/logo_black.svg" aria-hidden="true">
  </div>

  <div class="header-row secondary-row">
    <h1 data-qa="tnb-header">
      <a [routerLink]="['/']">
        TNB-Portal UFLA
      </a>

      <div class="user-role">
      @if (user$ | async; as profile) {
        <mat-icon svgIcon="innogy_picto_cogeneration-unit"></mat-icon>
        <small data-qa="profile-organisationsName">{{ profile.organisationsName }}</small>
        <small>&nbsp;</small>
        <small data-qa="profile-organisationsTyp">
          ({{ profile.organisationsTyp | orgTypeReadable }})
        </small>
        <small>&nbsp;</small>
        <small data-qa="profile-userTyp">
          {{ authenticationService.isAdmin(profile) | roleFilter }}
        </small>
      }
      </div>
    </h1>

    <nav class="tnb-header-menu">

      @if (user$ | async; as profile) {
        <button matButton="filled"
                class="menu-button"
                [class.menu-open]="menuTrigger.menuOpen"
                data-qa="menu-button"
                [matMenuTriggerFor]="menu"
                #menuTrigger="matMenuTrigger">
          <mat-icon [svgIcon]="menuTrigger.menuOpen ? 'innogy_picto_close' : 'innogy_picto_menu'"></mat-icon>
          {{ menuTrigger.menuOpen ? 'Schließen' : 'Menü' }}
        </button>
        <mat-menu #menu="matMenu" class="main-menu">
          <a mat-menu-item routerLink="/dashboard">
            <mat-icon svgIcon="innogy_picto_clipboard"></mat-icon>
            <span>Übersicht</span>
          </a>
          @if (authenticationService.isVnb(profile) || authenticationService.isUenb(profile)) {
            <a mat-menu-item
               data-qa="menu-netzbetreiberliste" [routerLink]="['/netzbetreiber/list']">
              <mat-icon svgIcon="innogy_picto_pylon"></mat-icon>
              <span>Netzbetreiberliste</span>
            </a>
          }
          @if (authenticationService.isVnb(profile)) {
            <a mat-menu-item
               data-qa="menu-anleitungen" [routerLink]="['/anleitungen']">
              <mat-icon>library_books</mat-icon>
              <span>Anleitung-Verwaltung</span>
            </a>
          }
          <a mat-menu-item data-qa="menu-anleitungen"
             (click)="this.anleitungService.downloadFile(profile.organisationsTyp)"
             [disabled]="(this.anleitungService.anleitungPresentForRole$ | async) === false">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>Anleitung</span>
          </a>
          <a mat-menu-item (click)="openKontaktdaten()" data-qa="menu-kontaktdaten">
            <mat-icon svgIcon="innogy_picto_person_info"></mat-icon>
            <span>Kontaktdaten</span>
          </a>
          <a mat-menu-item data-qa="menu-logout-button" (click)="logout()">
            <mat-icon svgIcon="innogy_picto_power_on_off"></mat-icon>
            <span>Abmelden</span>
          </a>
        </mat-menu>
      } @else {
        <button matButton="filled"
                data-qa="menu-login-button"
                (click)="login()">
          <mat-icon>launch</mat-icon>
          <span>Zum Login</span>
        </button>
      }

    </nav>
  </div>
</header>
